import * as React from 'react';
import { connect } from 'react-redux';
import { Button, FormGroup, FormText, Input, Row, Col } from "reactstrap";
import { Dispatch } from 'redux';
import { useState, useRef } from 'react';
import { episodeAction } from '../../actions/episodeAction';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import uploadFileToBlob from '../../services/Azure/azureBlob';
import parse from "html-react-parser";
import { useHistory } from "react-router-dom";
import BookMarkAudio from './bookmarkAudio';
import { getLoggedUserId, getLoggedUsername, getLoggedUser, getIsAdminLogged } from '../../services/selectors/Accounts';
import { showAlert } from "../common/functions";
import { DABButton, DABDropDown, DABHtmlEditor, DABTextBox, DABBackToList, LoadingSpinnerModal, AudioModal } from '../../components/dab';
import moment from 'moment';
import { userAction } from '../../actions/userAction';
import { bibleAction } from '../../actions/bibleAction';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

interface IEpisodeProps {
	dispatch: Dispatch<any>;
	episodeData: any;
	userData: any;
	bibleData: any;
	callback: any;
	id: number;
}

class Guid {
	static newGuid() {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
			var r = Math.random() * 16 | 0,
				v = c === 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		});
	}
}

const hasValidAuthorId = (authorId: any) => authorId !== null && authorId !== undefined && parseInt(authorId) > 0;

const EpisodeDetail: React.SFC<IEpisodeProps> = ({
	dispatch, episodeData, userData, bibleData, callback, id }) => {
	const history = useHistory();
	var bookmarkInit = {
		bookmarkTypeId: 0,
		bookmarkPosition: 0
	};

	let dateFormat = "MM/DD/YYYY";

	var episodesInput = {
		channelId: 0,
		channelTitle: "",
		bibleId: -1,
		bibleTitle:"",
		authorUserId: 0,
		readingId: -1,
		readingTitle:"",
		episodeTypeCode: "reading",
		resourceMediaTypeCode: "",
		title: "",
		descriptionHtml: "",
		publishAtUtc: "", 
		resourceDuration: 0,
		resourceBytes: 0,
		resourceUrl: "",
		bookMarkList: [bookmarkInit]		
	}
	let anyVa: any; 

	const [formSubmit, setFormSubmit] = useState(false);
	const [isBookMark, setIssBookMark] = useState(false);
	const [isReviewPage, setIsReviewPage] = useState(false);
	const [content, setContent] = useState("");
	const initialValue = [{ text: "", value: -1, checked: false }];
	const [isChannelLoaded, setIsChannelLoaded] = useState(false);
	const [chanList, setChanList] = useState(initialValue);
	const [typeList, setTypeList] = useState([{ text: "", value: "", checked: false }]);
	const [bookMarkTypeList, setBookMarkTypeList] = useState(initialValue);
	const [isAudioChanged, setIsAudioChanged] = useState(false);
	const [isErrorOnPage, setIsErrorOnPage] = useState(false); 
	const [position, setPosition] = useState(0);
	const [isReadingInit, setReadingInit] = useState(false);
	const [isReadingInitByBible, setReadingInitByBible] = useState(false);
	const [fileSelected, setFileSelected] = useState(anyVa);
	const [fileSelectedName, setFileSelectedName] = useState("");
	const [fileRequired, setFileRequired] = useState(true);
	const [input, setInput] = useState(episodesInput);
	const [isActive, setIsActive] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const [showAudioModal, setShowAudioModal] = useState(false);
	const [isDetailLoaded, setDetailLoaded] = useState(false);
	const [loggedUserName, setLoggedUserName] = useState("");
	const [loggedUser, setLoggedUser] = useState("");
	const [loggedUserId, setLoggedUserId] = useState(-1);
	const [isUserByRolesLoaded, setIsUserByRolesLoaded] = useState(false);
	const [authorList, setAuthorList] = useState([{ text:"", value:-1 }])
	const initialBibleObject = [{ text: "", value: -1, checked: false, uniqueCode: "" }];
	const [bibleList, setBibleList] = useState(initialBibleObject);
	const [isBibleListLoaded, setIsBibleListLoaded] = useState(false);
	const [isDirty, setIsDirty] = useState<boolean>(false)
	const [isBibleSearch, setIsBibleSearch] = useState(false);
	const [isReadingNotFound, setIsReadingNotFound] = useState(false);
	const isReadingNotFoundRef = useRef(false);
	
	React.useEffect(() => {
		const frompath = sessionStorage.getItem('fromPath')
		if (frompath) {
			sessionStorage.removeItem('fromPath')
		}
		setInput({
			...input,
			publishAtUtc: moment().format(dateFormat),
		});
		if (id !== 0) {
			dispatch(episodeAction.episodeGetDetail(id));
			setShowModal(true);
		}
		dispatch(episodeAction.episodeGetDropDownList());
		dispatch(userAction.userRoleGet("Episode"));
		const initBibleInputValue = {
			languageCodes: [] as string[],
			uniqueCodes: [] as string[],
			pageNumber: 1,
			pageSize: 100,
			sortColumn: "",
			sortDirection: "asc",
			isCommonFilter: false,
			isLanguageFilter : false
		};
		dispatch(bibleAction.bibleGetByFilter(initBibleInputValue));

		if (loggedUserName.trim() === "") {
			setLoggedUserName(getLoggedUsername);
		}

		if (loggedUserId === -1) {
			setLoggedUserId(getLoggedUserId);
			
		}
		if (loggedUser.trim() === "") {
			setLoggedUser(getLoggedUser)
		}
		if (input.authorUserId === 0) {
			setInput({ ...input, authorUserId: parseInt(getLoggedUserId()) })
		}
	}, []);

	const handleNotesChange = (evt) => {
		var newContent = evt.getData();
		setContent(newContent);
		setIsDirty(newContent !="")
	}

	const handlePositionChange = (position) => {
		setPosition(position);
	};

	const handleOnReadyHandler = () => {
		if (showModal) {
			setShowModal(false);
		}
	};

	const handleFileChange = (event) => {
		const fileFormat = event.target.files[0].name.split(".").pop()
		if (fileFormat === "mp3" || fileFormat === "m4a") {
			setFileSelected(event.target.files[0]);
			setFileSelectedName(event.target.files[0].name);
			var inp = input;
			const name = event.target.files[0].name;
			const lastDot = name.lastIndexOf('.');
			const ext = name.substring(lastDot + 1);
			inp.resourceBytes = event.target.files[0].size;
			handleComputeLength(event.target.files[0]).then(function (data: any) {
				inp.resourceDuration = data.length;
			});
			inp.resourceMediaTypeCode = ext;
		} else {
			event.target.value = "";
			showAlert("Please select a valid audio file", true);			
		}
		if (input.bookMarkList.length >= 0) {
			var inp = input
			inp.bookMarkList = [bookmarkInit]
			setInput(inp)
		}
		setIsDirty(true)
	};

	const handleDateChange = (date) => {
		let name = "publishAtUtc"
		let value = moment(date).format('YYYY-MM-DD');

		if (input.episodeTypeCode === "community") {
			setInput({ ...input, [name]: value, title: "Community Prayers - " + moment(value).format('LL'), readingId: -1, readingTitle: "" })
		} else if (input.episodeTypeCode === "reading") {
			if (moment(value).get('year').toString().split('').length == 4)
				handleGetReading(input.episodeTypeCode, value, input.channelId);
			setReadingInit(true);
			setInput({
				...input,
				[name]: value,
				title: moment(value).format('LL')
			});
		} else {
			setInput({ ...input, [name]: value, readingId: -1, readingTitle: "" });
		}
		setIsDirty(true)
	}

	// Looks up a channel's configured Default Episode Author from chanList by channelId.
	const getChannelDefaultAuthorId = (channelIdValue: any) => {
		const channel: any = chanList.find((data: any) => data.value?.toString() === channelIdValue?.toString());
		return channel?.authorUserId;
	};

	const handleInputChange = (event) => {
		let name = event.target.name;
		let value = event.target.value;

		setInput({ ...input, [name]: value });

		if (name === "bibleId") {
			setIsReadingNotFound(false);
			isReadingNotFoundRef.current = false;
			const bible = bibleList.filter((data: any) => data.value == value);
			if (bible.length > 0 && bible[0].uniqueCode && input.readingTitle && input.readingTitle.trim() !== "" && input.episodeTypeCode === "reading") {
				setIsBibleSearch(true);
				setShowModal(true);
				dispatch(bibleAction.bibleTranslationSearch(input.readingTitle, bible[0].uniqueCode));
			}
		}

		if (name === "channelId") {
			const channelDefaultAuthorId = getChannelDefaultAuthorId(value);
			const wasAuthorEnforcedByPreviousChannel = hasValidAuthorId(getChannelDefaultAuthorId(input.channelId));

			let nextAuthorUserId = input.authorUserId;

			if (hasValidAuthorId(channelDefaultAuthorId)) {
				nextAuthorUserId = parseInt(channelDefaultAuthorId);
			} else if (wasAuthorEnforcedByPreviousChannel) {
				const loggedUserId = parseInt(getLoggedUserId());
				const isLoggedUserEligibleAuthor = authorList.some((author: any) => parseInt(author.value) === loggedUserId);
				nextAuthorUserId = isLoggedUserEligibleAuthor ? loggedUserId : -1;
			}

			setInput({
				...input,
				[name]: value,
				authorUserId: nextAuthorUserId
			});
		}

		if (name === "episodeTypeCode") {
			if (value === "reading") {				
				handleGetReading(value, input.publishAtUtc, input.channelId);
				setReadingInit(true);
				setInput({...input,
					[name]: value,
					title: moment(input.publishAtUtc).format('LL'),
				});
			} else if (value === "community") {
				setInput({ ...input, [name]: value, title: "Community Prayers - " + moment(input.publishAtUtc).format('LL'), readingId: -1, readingTitle: ""})
			} else {
				setInput({ ...input, [name]: value, title: "", readingId: -1, readingTitle: "" })
			}
		}
		setIsDirty(true)
	};

	if (episodeData) {
		if (episodeData.isError && !isErrorOnPage && !episodeData.isSuccess && !episodeData.isReadingDataSuccess) {
			if (showModal) {
				setShowModal(false);
			}
			episodeData.isError = false;
			if (episodeData.status === 'Unauthorized') {
				sessionStorage.setItem('fromPath', window.location.pathname + window.location.search)
				history.push("/401");				
			} else {
				showAlert(episodeData.status, true);
			}
			setIsErrorOnPage(false);
		}
		
		if (showModal && formSubmit && !episodeData.isFormSubmit && episodeData.isSuccess) {
			if (episodeData.isSuccess) {
				if (showModal) {
					setShowModal(false);
				}
				window.localStorage.setItem('alertMessage', episodeData.status);
				window.location.href = "/episode";
			}
		}

		if (episodeData.isDetailComplete) {
			if (!isDetailLoaded && episodeData.episodesInput) {
				if (episodeData.episodesInput !== null) {
					episodeData.episodesInput.publishAtUtc = episodeData.episodesInput.publishAtUtc.substr(0, 10);
					var inp = episodeData.episodesInput;
					if (inp.readingId === null) {
						inp.readingId = -1;
					}
					setInput(inp);
					setContent(episodeData.episodesInput.descriptionHtml);
					callback(episodeData.episodesInput.title);
					setDetailLoaded(true);
					episodeData.isSuccess = false;
					episodeData.status = null;
				}
			}			
		}
		if (userData && userData.isSuccess && !isUserByRolesLoaded) {
			if (userData.isUserByRolesLoaded && !isUserByRolesLoaded) {
				if (userData.usersByRolesData && userData.usersByRolesData.length > 0) {
					let options = userData.usersByRolesData.map(el => (
						{ text: el.name + " -  " + el.userName, value: el.userId }
					));
					options.unshift({ text: "Select an author", value: -1 });
					setAuthorList(options);
					setIsUserByRolesLoaded(true);
				}
			}
		}
		if (episodeData && episodeData.isDropdownListSuccess && !isChannelLoaded) {
			if (episodeData.channels.length > 0) {
				episodeData.status = null;
				var list: any[] = [];
				list.push(initialValue);
				episodeData.channels.sort((a: any, b: any) => a.title?.localeCompare(b.title)).forEach((data) => {
					if (data.isActive) {
						var item = { text: data.title, value: data.channelId, checked: false, authorUserId: data.authorUserId };
						list.push(item);
					}
				});
				setChanList(list);
				list = [];
				list.push(initialValue);
				episodeData.episodeTypes.forEach((data) => {
					var item = { text: data.title, value: data.episodeTypeCode, checked: false };
					list.push(item);
				});
				setTypeList(list);   
				list = [];
				list.push(initialValue);
				list = [];
				episodeData.bookMarkTypes.forEach((data) => {
					var item = { text: data.title, value: data.bookmarkTypeId, checked: false };
					list.push(item);
				});
				setBookMarkTypeList(list);
				setIsChannelLoaded(true);
				episodeData.isSuccess = false;
			}
		}
		if (isReadingInit && episodeData.isReadingDataSuccess) {
			if (episodeData.readingData) {
				episodeData.status = null;
				setInput({
					...input,
					readingId: episodeData.readingData.readingId,
					readingTitle: episodeData.readingData.title,
					bibleId: episodeData.readingData.bibleId
				});
			}
			else {
				setInput({
					...input,
					readingId: -1,
					readingTitle: ""
				});
				showAlert(episodeData.status, true);
			}

			setReadingInit(false);
			episodeData.isSuccess = false;
			episodeData.status = null;
			episodeData.isReadingDataSuccess = false;
			episodeData.isError = false;
			if (showModal) {
				setShowModal(false);
			}
		}

		if (isReadingInitByBible && episodeData.isReadingIdSuccess) {
			if (episodeData.readingIdData) {
				episodeData.status = null;
				setInput({
					...input,
					readingId: episodeData.readingIdData
				});

			}
			setReadingInitByBible(false);
			episodeData.isSuccess = false;
			episodeData.status = null;
			episodeData.isReadingIdSuccess = false;
			if (showModal) {
				setShowModal(false);
			}
		}		
	}

	if (bibleList && !isBibleListLoaded) {
		if (bibleData.items.length > 0) {
			var list: any[] = [];
			bibleData.items.sort((a: any, b: any) => a.title?.localeCompare(b.title)).forEach((data) => {
				var item = { text: data.title + " (" + data.uniqueCode + ")", value: data.bibleId, checked: true, uniqueCode: data.uniqueCode };
				list.push(item);
			});
			setBibleList(list);

			setIsBibleListLoaded(true);
		}
	}

	if (isBibleSearch && bibleData && bibleData.isSearch && bibleData.isSuccess) {
		bibleData.isSearch = false;
		setIsBibleSearch(false);
		if (bibleData.readingText == "" || bibleData.readingText == null) {
			setIsReadingNotFound(true);
			isReadingNotFoundRef.current = true;
			showAlert("Reading not found", true);
		} else {
			setIsReadingNotFound(false);
			isReadingNotFoundRef.current = false;
		}
		if (showModal) {
			setShowModal(false);
		}
	}

	const handleGetReading = (episodeType, publishDate, channelId) => {
		if (episodeType === 'reading' && publishDate && channelId > 0) {
			dispatch(episodeAction.episodeGetReading({ channelId: channelId, selectedDate: publishDate }));
			setShowModal(true);
		}
	}

	const handleChangeBookMarkType = (event, index) => {
		var values = input.bookMarkList;
		values[index].bookmarkTypeId = parseInt(event.target.value);
		setInput({ ...input, bookMarkList: values });
	}

	const handleAddBookmark = () => {
		var inp = bookmarkInit;
		var list = input.bookMarkList;
		if (list.length === 1 && !isActive && list[0].bookmarkTypeId===0) {
			setIsActive(true);
			list = []
			inp.bookmarkPosition = Math.round(position * 100) / 100;
			inp.bookmarkTypeId = 1;
			list.push(inp);
			setInput({ ...input, bookMarkList: list });
			
		}
		else {
			if (list.length >= 5) {
				showAlert("Bookmark limit exceeded", true);
			} else {
			inp.bookmarkPosition = Math.round(position * 100) / 100;
			inp.bookmarkTypeId = 1;
			list.push(inp);
			setInput({ ...input, bookMarkList: list });
			}
		}
		setIsDirty(true)
	}

	const handleRemoveBookmark = (index) => {
		var list = input.bookMarkList;
		var value = list[index];
		list = list.filter(function (item) {
			return item !== value
		})
		var isSame = list.length == input.bookMarkList.length && list.every((element, index)=> {
			return element === input.bookMarkList[index];
		});
		if (!isSame) {
			setIsDirty(true)
		}
		setInput({ ...input, bookMarkList: list });
	}

	function handleComputeLength(file) {
		return new Promise((resolve) => {
			var objectURL = URL.createObjectURL(file);
			var mySound = new Audio(objectURL);
			mySound.addEventListener(
				"canplaythrough",
				() => {
					URL.revokeObjectURL(objectURL);
					resolve({
						file,
						length: mySound.duration
					});
				},
				false,
			);
		});
	}

	const handleSubmit = async (event) => {
		event.preventDefault();
		sessionStorage.removeItem("createEpisode")
		var inp = input
		inp.descriptionHtml = content;
		// the author can only be cleared when the field is changeable. Fall back to the logged in
		// user so an episode is never saved without an author.
		if (!hasValidAuthorId(inp.authorUserId)) {
			inp.authorUserId = parseInt(getLoggedUserId());
		}
		const val = input.bookMarkList.map((item) => item.bookmarkTypeId)
		var isDuplicate = val.some((item, i) => val.indexOf(item) != i);
		if (isDuplicate) {
			showAlert("Bookmark type must be unique", true);
		} else {  
			setShowModal(true);
			if (isDetailLoaded && !isAudioChanged) {
				
			}
			else {
				const isTest = sessionStorage.getItem('isTest');
				var fileName = Guid.newGuid() + input.title.replace(/ /g, "");
				const name = fileSelected.name;
				const lastDot = name.lastIndexOf('.');
				const ext = name.substring(lastDot + 1);
				inp.resourceBytes = fileSelected.size;
				handleComputeLength(fileSelected).then(function (data: any) {
					inp.resourceDuration = data.length;
				});
				inp.resourceMediaTypeCode = ext;
				const blobsInContainer = isTest ? fileSelected.name: await uploadFileToBlob(fileSelected, fileName, "Audio");
				
				if (blobsInContainer === "") {
					alert("File not uploaded");
					return;
				}
				setInput({
					...input,
					resourceUrl: blobsInContainer,
				});
				inp.resourceUrl = blobsInContainer;
			}

			setFormSubmit(true);
			dispatch(episodeAction.episodeSave({ episode: inp }));
		}
	};

	const handleNextClick = (event) => {
		event.preventDefault();
		if (isBookMark) {
			const val = input.bookMarkList.map((item)=>item.bookmarkTypeId )
			var isDuplicate = val.some((item, i) => val.indexOf(item) != i);
			if (isDuplicate) {
				showAlert("Bookmark type must be unique", true);
			} else {
				setIssBookMark(false);
				setIsReviewPage(true);
				id > 0 ? callback(`Review ${input.title}`) : callback("Review Create New");
			}			
		} else if (!isBookMark && !isReviewPage) {
			if (input.readingId <= 0 && input.episodeTypeCode == 'reading') {
				showAlert("Reading detail can not be empty.", true);
				return;
			}
			if ((isReadingNotFound || isReadingNotFoundRef.current) && input.episodeTypeCode == 'reading') {
				showAlert("Reading not found", true);
				return;
			}
			if (isBibleSearch) {
				showAlert("Please wait, validating reading...", true);
				return;
			}
			if (!hasValidAuthorId(input.authorUserId)) {
				// keep the review screen and the saved episode on the same author
				setInput({ ...input, authorUserId: parseInt(getLoggedUserId()) });
			}
			if (id <= 0) { setDetailLoaded(false)}
			setIssBookMark(true);
			setIsReviewPage(false);			
			id > 0 ? callback(`Create Audio Bookmarks of ${input.title}`) : callback("Create Audio Bookmarks");
			if (!showModal) {
				setShowModal(true);
			}
		} else if (isReviewPage) {
			handleSubmit(event);
		}
	}

	const handleBackClick = (event) => {
		sessionStorage.removeItem('createEpisode')
		event.preventDefault();
		if (fileSelected) {
			setFileRequired(false);
		}
		if (isBookMark) {
			setIssBookMark(false);
			setIsReviewPage(false);
			if (id > 0) callback(input.title)
			else callback("Create New")
		}
		else if (!isDetailLoaded && !isBookMark && !isReviewPage) {
			history.goBack();
		}
		else if (isReviewPage) {
			setIssBookMark(true);
			setIsReviewPage(false);
			callback("Create Audio Bookmarks");
			if (!showModal) {
				setShowModal(true);
			}
		}
	}

	React.useEffect(() => {
		const episode = sessionStorage.getItem('createEpisode');
		if (episode) {
			const episodeData = JSON.parse(episode);
			if (Object.keys(episodeData).length > 0 && episodeData !== null) {
				setInput({
					...input,
					channelId: episodeData.channelId,
					publishAtUtc: episodeData.date,
					title: moment(episodeData.date).format('MMMM DD, YYYY'),
					authorUserId: parseInt(getLoggedUserId()),
				})
				handleGetReading(episodeData.episodeTypeCode, episodeData.date, episodeData.channelId);
				setReadingInit(true)
			}
		}
	}, [])
	
	React.useEffect(() => {
		const eventHandler = (event: BeforeUnloadEvent) => {
			var sessionExpiry = window.localStorage.getItem('SESSIONEXPIRY');
			const inSession = Date.now() < Number(sessionExpiry)
			if (!formSubmit && inSession) {
				event.preventDefault();
				event.returnValue = "";
			}
		};
		if (isDirty) { window.addEventListener("beforeunload", eventHandler) }
		return () => { window.removeEventListener("beforeunload", eventHandler) };
	}, [isDirty && !formSubmit])

	const channelDefaultAuthorId = getChannelDefaultAuthorId(input.channelId);
	const isAuthorEnforcedByChannel = hasValidAuthorId(channelDefaultAuthorId);

	React.useEffect(() => {
		if (!isDetailLoaded && isAuthorEnforcedByChannel && parseInt(input.authorUserId as any) !== parseInt(channelDefaultAuthorId)) {
			setInput({ ...input, authorUserId: parseInt(channelDefaultAuthorId) });
		}
	}, [isDetailLoaded, isAuthorEnforcedByChannel, channelDefaultAuthorId]);

	// While editing, the saved author may no longer be in the role based author list
	// (role removed or user deactivated). Add the episode's own author to the list so it
	// stays selected instead of falling back to "Select an author".
	React.useEffect(() => {
		if (!isDetailLoaded || !isUserByRolesLoaded) { return; }
		const episodeAuthorId = parseInt(input.authorUserId as any);
		if (!hasValidAuthorId(episodeAuthorId)) { return; }
		if (authorList.some((author: any) => parseInt(author.value) === episodeAuthorId)) { return; }

		const episodeAuthor: any = episodeData?.episodesInput ?? {};
		const authorName = episodeAuthor.author ?? "";
		setAuthorList([...authorList, { text: authorName, value: episodeAuthorId }]);
	}, [isDetailLoaded, isUserByRolesLoaded, input.authorUserId, authorList]);

	return (
		<div className="episode-detail">
			{showModal && (<LoadingSpinnerModal isShowModal={showModal} modalChange={() => { } } />)}
			<div className='card-box'>
				{!isBookMark && !isReviewPage && !isDetailLoaded && (id === 0) && (
					<form name="createform" onSubmit={handleNextClick} className="create-form">
						<div className={["row mb-3"].join(" ")}>
							<label data-testid="lblChannelCreate" htmlFor="channel" className={["col-sm-2 col-form-label"].join(" ")}>Channel</label>
							<div data-testid="channelContainer" className={["col-sm-5"].join(" ")}>
								<DABDropDown id="channelId" value={input.channelId} isRequired={true}
									onChange={(event) => { handleInputChange(event) }} options={chanList} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label data-testid="lblPublishAtCreate" htmlFor="publishAt" className={["col-sm-2 col-form-label"].join(" ")}>Date</label>
							<div data-testid="publishAtContainer" className={["col-sm-5"].join(" ")}>
								{input.publishAtUtc === "" && <DABTextBox type="password" id="date" isRequired={true} isHover={false} className="fake-date-input form-control" value={""} />}
									<DatePicker
									className="form-control date-picker-input"
									showMonthDropdown
									showYearDropdown
									dropdownMode="select"
									dateFormat="MM/dd/yyyy"
									selected={input.publishAtUtc != "" ? moment(input.publishAtUtc).local().toDate() : null}
									onChange={handleDateChange}  
									placeholderText="MM/DD/YYYY"
									onKeyDown={(e) => { e.preventDefault() }}
								/> 									
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label data-testid="lblEpisodeTypeCreate" htmlFor="episodeType" className={["col-sm-2 col-form-label"].join(" ")}>Episode Type</label>
							<div data-testid="episodeTypeContainer" className={["col-sm-5"].join(" ")}>
								<DABDropDown type="select" id="episodeTypeCode" isRequired={true} onChange={(event) => { handleInputChange(event) }}
									value={input.episodeTypeCode} options={typeList} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label data-testid="lblTitleCreate" htmlFor="title" className={["col-sm-2 col-form-label"].join(" ")}>Title</label>
							<div data-testid="titleContainer" className={["col-sm-5"].join(" ")}>
								<DABTextBox type="text" id="title" data-testid="title" isRequired={true} isHover={false}
									onChange={(event) => { handleInputChange(event) }}
									value={input.title} readonly={input.episodeTypeCode == "other" ? false : true} maxLength={100} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")} style={{ display: `${input.episodeTypeCode == "reading" ? '' : 'none'}` }}>
							<label data-testid="lblReadingCreate" htmlFor="reading" className={["col-sm-2 col-form-label"].join(" ")}>Reading</label>
							<div data-testid="readingContainer" className={["col-sm-5"].join(" ")}>
								<DABTextBox type="text" id="summaryText" data-testid="readingTitle" isRequired={true} isHover={false}
									onChange={(event) => { handleInputChange(event) }}
									value={input.readingTitle} readonly={true} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")} style={{ display: `${((input.episodeTypeCode === "reading") && (input.readingTitle.trim().length > 0)) ? '' : 'none'}` }}>
							<label data-testid="lblBibleCreate" htmlFor="bible" className={["col-sm-2 col-form-label"].join(" ")}>Bible</label>
							<div data-testid="bibleContainer" className={["col-sm-5"].join(" ")}>
								<Input type="select" className="form-select" id="bibleId" name="bibleId"
									value={input.bibleId} onChange={(event) => { handleInputChange(event); }}>
									{bibleList && bibleList.map((data: any) =><option key={data.value} value={data.value}>{data.text}</option>)}
								</Input>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label data-testid="lblNotesCreate" htmlFor="notes" className={["col-sm-2 col-form-label"].join(" ")}>Notes</label>
							<div data-testid="notesContainer" className={["col-sm-5"].join(" ")}>
								<DABHtmlEditor content={content} onChange={handleNotesChange} id="description" />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label data-testid="lblAuthorCreate" htmlFor="author" className={["col-sm-2 col-form-label"].join(" ")}>Author</label>
							<div data-testid="authorContainer" className={["col-sm-5"].join(" ")}>
								<DABDropDown id="authorUserId" 
									value={input.authorUserId}
									isRequired={true}
									disabled={isAuthorEnforcedByChannel || !getIsAdminLogged()}
									className={isAuthorEnforcedByChannel || !getIsAdminLogged() ? 'p-0' : ''}
									onChange={(event) => { handleInputChange(event) }} options={authorList} />
								{isAuthorEnforcedByChannel && (
									<FormText color="muted" data-testid="authorEnforcedByChannelText">
										Author is set by the channel's Default Episode Author and cannot be changed.
									</FormText>
								)}
							</div>
							
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label data-testid="lblAudioFileCreate" htmlFor="audioFile" className={["col-sm-2 col-form-label"].join(" ")}>Audio File</label>
							<div data-testid="audioFileContainer" className={["col-sm-5"].join(" ")}>
								<FormGroup>
									<Input type="file" name="audioFileUpload" id="audioFile" accept=".mp3, .m4a" required={fileRequired}
										onChange={(e) => { handleFileChange(e) }} />
									<FormText color="muted">
										<div data-testid="selectedFileName">Selected File: {fileSelectedName}</div><br />
										only audio files (.mp3 .m4a), Max file size 200mb
									</FormText>
								</FormGroup>
							</div>
						</div>
						<Row className="ed-buttons">
							<Col lg="3" data-testid="cancelButtonContainer">
								<DABButton id="backToCreate" onClick={(e) => { handleBackClick(e); }} value="CANCEL">CANCEL</DABButton>
							</Col>
						
							<Col lg="3" data-testid="nextButtonContainer">
								<DABButton id="submit" className="btn-submit-frm" value="NEXT">NEXT</DABButton>
							</Col>
						</Row>
					</form>
				)}

				<div style={{ display: `${isBookMark ? '' : 'none'}` }} >
					{isBookMark && fileSelected && fileSelected !== null && fileSelected !== "" && (
						<div className="wave-preview">
							<h5 data-testid="clickPlayMessage">Click the play button to hear recording.</h5>
							<h5 data-testid="createBookmarkMessage">To create a bookmark, drag the slider to a point on the wavelength. Click the + to add a bookmark.</h5>
							<br />
							<br />
							<div data-testid="bookMarkAudioContainer">
								<BookMarkAudio data-testid="createBookMarkAudio" src={fileSelected} handlePositionChange={handlePositionChange} handleReadyHandler={handleOnReadyHandler} id="cors" handleAddBookmark={handleAddBookmark} />
							</div>
							<br />
							<br />
							<div>
								{!showModal && isActive && input.bookMarkList.map((value, index) => {
									return (
										<div>
											<Row>
												<Col lg="1">
													{(index + 1).toString()}
												</Col>
												<Col lg="6">
													<Input type="select"
														className="form-select" id={"bookmarkTypeId" + index} name={"bookmarkTypeId" + index}
														value={value.bookmarkTypeId}
														onChange={(event) => { handleChangeBookMarkType(event, index); }} >
														{bookMarkTypeList && bookMarkTypeList.map((data: any) =>
															<option key={data.value + index} value={data.value}>{data.text}</option>
														)}
													</Input>
												</Col>
												<Col lg="3">
													<input disabled={true} className={["form-control"].join(" ")} id={"bookmarkPosition" + index} name={"bookmarkPosition" + index} value={value.bookmarkPosition} />
												</Col>
												<Col lg="2">
													<FontAwesomeIcon size='2x' icon={faTrashAlt} data-bs-toggle="tooltip" cursor='pointer'
														data-bs-placement="bottom" title="Delete" onClick={() => { handleRemoveBookmark(index); }} />
												</Col>
											</Row>
											<br />
										</div>)
								}
								)}
							</div>
							<br />
							<br />
							<br />
							<Row className="ed-buttons">
								<Col lg="11" data-testid="backToCreateButtonContainer">
									<Button id="backToCreate" className="" onClick={(e) => { handleBackClick(e); }}>BACK</Button>
								</Col>
								
								<Col lg="1" data-testid="nextToPreviewButtonContainer">
									<DABButton id="NextToPreview" className="btn-submit-frm" onClick={(e) => { handleNextClick(e); }} value="NEXT"></DABButton>
								</Col>
							</Row>
						</div>
					)}
				</div>
				{isReviewPage &&
				<div style={{ display: `${isReviewPage ? '' : 'none'}` }} className="preview-form">
					<form name="previewform" >
						<div className={["row mb-3"].join(" ")}>
							<label data-testid="lblChannelPreview" htmlFor="channel" className={["col-sm-2 col-form-label"].join(" ")}>Channel</label>
							<div data-testid="prevChannelContainer" className={["col-sm-5"].join(" ")}>
								{chanList.find(x => x.value === parseInt(input.channelId.toString()))?.text}
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label data-testid="lblPublishAtPreview" htmlFor="date" className={["col-sm-2 col-form-label"].join(" ")}>Date</label>
							<div data-testid="prevPublishContainer" className={["col-sm-5"].join(" ")}>
								{moment(input.publishAtUtc).format(dateFormat)}
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label data-testid="lblEpisodeTypePreview" htmlFor="episodeType" className={["col-sm-2 col-form-label"].join(" ")}>Episode Type</label>
							<div data-testid="prevEpisodeTypeContainer" className={["col-sm-5"].join(" ")}>
								{typeList && typeList.find(x => x.value == input.episodeTypeCode)?.text}
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label data-testid="lblTitlePreview" htmlFor="title" className={["col-sm-2 col-form-label"].join(" ")}>Title</label>
							<div data-testid="prevTitleContainer" className={["col-sm-5"].join(" ")}>
								{input.title}
							</div>
						</div>
						<div className={["row mb-3"].join(" ")} style={{ display: `${(input.episodeTypeCode === "reading") ? '' : 'none'}` }}>
							<label data-testid="lblReadingPreview" htmlFor="reading" className={["col-sm-2 col-form-label"].join(" ")}>Reading</label>
							<div className={["col-sm-5"].join(" ")} data-testid="prevReadingTitleContainer">
								{input.readingTitle}
							</div>
						</div>
						<div className={["row mb-3"].join(" ")} style={{ display: `${(input.episodeTypeCode === "reading") ? '' : 'none'}` }}>
							<label data-testid="lblBiblePreview" htmlFor="bible" className={["col-sm-2 col-form-label"].join(" ")}>Bible</label>
							<div className={["col-sm-5"].join(" ")} data-testid="prevBibleTitleContainer">
								{bibleList && bibleList.find(x => x.value == input.bibleId)?.text}
							</div>								
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label data-testid="lblNotesPreview" htmlFor="notes" className={["col-sm-2 col-form-label"].join(" ")}>Notes</label>
							<div data-testid="prevNotesContainer" className={["col-sm-5"].join(" ")}>
								{content !== null && (
									<span>{parse(content)}</span>
								)}
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label data-testid="lblAuthorPreview" htmlFor="author" className={["col-sm-2 col-form-label"].join(" ")}>Author</label>
							<div className={["col-sm-5"].join(" ")} data-testid="prevAuthorContainer">
								{authorList && authorList.find(x => x.value == input.authorUserId)?.text}
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label data-testid="lblAudioFilePreview" htmlFor="audioFile" className={["col-sm-2 col-form-label"].join(" ")}>Audio File</label>
							<div data-testid="prevAudioFileContainer" className={["col-sm-5"].join(" ")}>
								{fileSelectedName}
							</div>
						</div>

						<div className={["row mb-3"].join(" ")}>
							<label data-testid="lblBookmarksPreview" htmlFor="bookMarks" className={["col-sm-2 col-form-label"].join(" ")}>Bookmarks</label>
							<div className={["col-sm-5"].join(" ")}>
								<div>
									{isActive && input.bookMarkList && input.bookMarkList.map((value, index) => {
										return (
											<div className="bookmarks-list">
												<Row >
													<Col lg="2">
														{(index + 1).toString()}
													</Col>
													<Col lg="5">
														{bookMarkTypeList.find(x => x.value === value.bookmarkTypeId)?.text}
													</Col>
													<Col lg="5">
														{value.bookmarkPosition}
													</Col>
												</Row>
												<br />
											</div>)
									}
									)}
								</div>
							</div>
						</div>
					</form>
					<Row className="ed-buttons" >
						<Col lg="3" data-testid="backToChangeButtonContainer">
							<DABButton value="Back" id="backToChange" className="" onClick={(e) => { handleBackClick(e); }}></DABButton>
						</Col>						
						<Col lg="3" data-testid="createButtonContainer">
							<DABButton value={id>0?"Update":"Create"} id="Create" className="btn-submit-frm" onClick={(e) => { handleSubmit(e); }}></DABButton>
						</Col>
					</Row>
				</div>
				}
				{isDetailLoaded && !isBookMark && !isReviewPage && (
					<div>
						<DABBackToList onClick={(e) => { history.goBack(); }} />
						<form name="createform" onSubmit={fileSelected ? handleNextClick: handleSubmit} className="update-form">
							<div className={["row mb-3"].join(" ")}>
								<label data-testid="lblChannelUpdate" htmlFor="channel" className={["col-sm-2 col-form-label"].join(" ")}>Channel</label>
								<div data-testid="channelContainer" id='link-container' className={["col-sm-5"].join(" ")}>
									<a href={`/channel?id=${input.channelId}`} className="detail-link" data-testid="channelLink">{input.channelTitle}</a>
								</div>
							</div>
							<div className={["row mb-3"].join(" ")}>
								<label data-testid="lblPublishAtUpdate" htmlFor="publishAt" className={["col-sm-2 col-form-label"].join(" ")}>Date</label>
								<div data-testid="publishAtContainer" className={["col-sm-5"].join(" ")}>
									<FormGroup><Input disabled type="text" name="publishAtUtc" id="exampleTime" value={moment(input.publishAtUtc).format(dateFormat)} /></FormGroup>
								</div>
							</div>
							{input.episodeTypeCode === "reading" && (
							<div>
								<div className={["row mb-3"].join(" ")}>
									<label data-testid="lblReadingUpdate" htmlFor="reading" className={["col-sm-2 col-form-label"].join(" ")}>Reading</label>
									<div data-testid="readingContainer" className={["col-sm-5"].join(" ")} id='link-container'>
										<a href={`/reading?id=${input.readingId}`} className="detail-link" data-testid="readingLink">{input.readingTitle}</a>
									</div>
								</div>
								<div className={["row mb-3"].join(" ")}>
									<label data-testid="lblBibleUpdate" htmlFor="bible" className={["col-sm-2 col-form-label"].join(" ")}>Bible</label>
									<div data-testid="bibleContainer" id='link-container' className={["col-sm-5"].join(" ")}>
										<a href={`/bible?id=${input.bibleId}`} className="detail-link" data-testid="bibleLink">{input.bibleTitle}</a>
									</div>
								</div>
							</div>
							)}
							<div className={["row mb-3"].join(" ")}>
								<label data-testid="lblTitleUpdate" htmlFor="title" className={["col-sm-2 col-form-label"].join(" ")}>Title</label>
								<div data-testid="titleContainer" className={["col-sm-5"].join(" ")}>
									<input className={["form-control label-edit"].join(" ")} id="title" name="title" value={input.title}
										onChange={(e) => setInput({ ...input, title: e.target.value })} maxLength={100} />
								</div>
							</div>
							
							<div className={["row mb-3"].join(" ")}>
								<label data-testid="lblAuthorUpdate" htmlFor="author" className={["col-sm-2 col-form-label"].join(" ")}>Author</label>								
								<div data-testid="authorContainer" className={["col-sm-5"].join(" ")}>
									<DABDropDown id="authorUserId"
										value={input.authorUserId} 
										isRequired={true}
										disabled={isAuthorEnforcedByChannel || !getIsAdminLogged()}
										className={"form-select " + (isAuthorEnforcedByChannel || !getIsAdminLogged() ? 'pe-0' : 'label-edit')}
										onChange={(event) => { handleInputChange(event) }} options={authorList} />
									{isAuthorEnforcedByChannel && (
										<FormText color="muted" data-testid="authorEnforcedByChannelText" className='ps-3'>
											Author is set by the channel's Default Episode Author and cannot be changed.
										</FormText>
									)}
								</div>
							</div>
							<div className={["row mb-3"].join(" ")}>
								<label data-testid="lblEpisodeTypeUpdate" htmlFor="episodeType" className={["col-sm-2 col-form-label"].join(" ")}>Episode Type</label>
								<div data-testid="episodeTypeContainer" className={["col-sm-5 text-field"].join(" ")}>
						  			 {typeList && typeList.find(x => x.value == input.episodeTypeCode)?.text}
								</div>
							</div>
							<div className={["row mb-3"].join(" ")}>
								<label data-testid="lblNotesUpdate" htmlFor="notes" className={["col-sm-2 col-form-label"].join(" ")}>Notes</label>
								<div data-testid="notesContainer" className={["col-sm-5"].join(" ")}>
									<DABHtmlEditor content={content} onChange={handleNotesChange} id="description" />
								</div>
							</div>

							<div className={["row mb-3"].join(" ")}>
								<input type="hidden" data-testid="fileLocationAzure" id="fileLocation" value={input.resourceUrl} />								
								<label data-testid="lblAudioFileUpdate" htmlFor="audioFile" className={["col-sm-2 col-form-label"].join(" ")}>Audio File</label>
								<div data-testid="audioFileContainer" className={["col-sm-5 text-field"].join(" ")}>
									<input type="file" name="audioFileUpload" id="audioFile" accept=".mp3, .m4a"
										onChange={(e) => { handleFileChange(e); setIsAudioChanged(true) }} style={{ display: 'black' }} />
									{fileSelected && !fileRequired && <label className="file-selected">{fileSelectedName}</label>}
									{!fileSelected && <a className="audio-url" onClick={()=>setShowAudioModal(true)}>{input.resourceUrl}</a>}
								</div>
							</div>
							{!fileSelected &&
								<div className={["row mb-3"].join(" ")}>
								<label data-testid="lblBookMarksUpdate" htmlFor="bookMarks" className={["col-sm-2 col-form-label"].join(" ")}>Bookmarks</label>
								<div data-testid="bookMarkContainer" className={["col-sm-8"].join(" ")}>
									<BookMarkAudio src={fileSelected ? fileSelected : input.resourceUrl} handlePositionChange={handlePositionChange}
										handleReadyHandler={handleOnReadyHandler} handleAddBookmark={handleAddBookmark}
										id={input.resourceUrl.includes("https://media.dailyaudiobible.com/") ? "no-cors" : "cors"} />
									<br />
									<br />
									<div>
										{input.bookMarkList && input.bookMarkList.map((value, index) => {
											return (
												<div key={index}>
													<Row>
														<Col lg="1">
															{(index + 1).toString()}
														</Col>
														<Col lg="6" data-testid="bookMarkTypeContainer">
															<Input type="select"
																className="form-select" data-testid={"bookmarkTypeId" + index} id={"bookmarkTypeId" + index} name={"bookmarkTypeId" + index}
																value={value.bookmarkTypeId} onChange={(event) => { handleChangeBookMarkType(event, index); }} >
																{bookMarkTypeList && bookMarkTypeList.map((data: any) =>
																	<option key={data.value + index} value={data.value}>{data.text}</option>
																)}
															</Input>
														</Col>
														<Col lg="3" data-testid="bookMarkPositionContainer">
															<input disabled={true} className={["form-control"].join(" ")}
																data-testid={"bookmarkPosition" + index}
																id={"bookmarkPosition" + index}
																name={"bookmarkPosition" + index}
																value={Math.round(value.bookmarkPosition * 100) / 100} />
														</Col>
														<Col lg="2">
															<FontAwesomeIcon data-testid="episodeBookmarkDeleteButton" size='2x' icon={faTrashAlt} data-bs-toggle="tooltip" cursor='pointer'
																data-bs-placement="bottom" title="Delete" onClick={() => { handleRemoveBookmark(index); }} />
														</Col>
													</Row>
													<br />
												</div>)
										}
										)}
									</div>
								</div>
							</div>}
							<div data-testid="saveChangesButtonContainer" className="ed-buttons">
								<DABButton value={fileSelected?"NEXT":"SAVE CHANGES"} id="Submit" className="btn-submit-frm"></DABButton>
							</div>
						</form>
					</div>
				)}
				<AudioModal data-testid="listenAudioModal" isShowModal={showAudioModal}
					audioUrl={input.resourceUrl} title={input.readingTitle}
					modalChange={() => setShowAudioModal(false)} />	
			</div>
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { episodeData, userData, bibleData } = state;
	return {
		episodeData,
		userData,
		bibleData
	};
};

export default connect(mapStateToProps)(EpisodeDetail);